import React, { Component } from 'react';
import classes from './MFAOptions.scss';
import TurnOnMFAContainer from '../TurnOnMFA/TurnOnMFAContainer';
import NeverAskAgainPopup from './NeverAskAgainPopup';
import MfaModal from '../Modal/MfaModal';
import { getLocalizedStrings } from '../mfaPageLocalizedStrings';
import TimeOut from '../TimeOut/TimeOut';
import LoadIndicator from '../../../../Common/CommonComponents/LoadingIndicator/loadingIndicator';

class MFAOptionsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      MFAOpen: false,
      MFAOpen1: false,
      isTimeout:false,
      showLoader:false
    };
    this.strings = getLocalizedStrings('MFAOptions');
    this.timeoutId = null;
  }

  componentDidMount(){
    const timer = 13*60*1000;
    /* update timer to 13 minutes for phase 2 as access token has expiry of 15mins */
    this.timeoutId = setTimeout(()=>{
      this.setState({isTimeout:true});
    }, timer);
  }

  componentWillUnmount(){
    if(this.timeoutId){
      clearTimeout(this.timeoutId);
    }
  }

  handleOpenModal = (e) => {
    e.stopPropagation();
    this.setState({ MFAOpen: true });
  };

  handleOpenModal1 = (e) => {
    e.stopPropagation();
    this.setState({ MFAOpen1: true });
  };

  handleCloseModal = () => {
    this.setState({ MFAOpen: false });
  };

  remindLater = (e) => {
    e.stopPropagation();
    this.setState({showLoader: true});
    let customerEmail = app.appService.getLocalStorage('mfaInfo') ? JSON.parse(app.appService.getLocalStorage('mfaInfo')).emailId : '';
    const reqObj = {
      email: customerEmail,
      eixSCEMFAStatus: 'RemindLater'
    };
    if (window.location.pathname === '/residential/rates/rate-plan-comparison-tool') {
      app.appService.setLocalStorage('userpath', app.appUtil.getAppRoutes().RATEANALYZER.RATE_LOADING_RESIDENTIAL);
      app.appService.setLocalStorage('isRedirectionRequired', true);
      app.appService.setSessionstorage('RateAnalyzerLoggedInStatus', true);
    }
    const { isSpocUser } = app.appService.getSessionstorage('nonMigratedData') || {};

    app.profileIdentityService.updateProfileV2(reqObj).then(() => {
      if (isSpocUser) {
        app.appUtil.navigateToFromLogin(app.appUtil.getAppRoutes().LOGIN.CHANGE_PASSWORD);
        return;
      } else {
        app.appService.removeSessionStorageItem(app.appService.appConstants.isPwdChanged);
      }
    }).catch(() => { 
      /* This is intentional */ 
    }).finally(() => {
      const data = app.appService.getSessionstorage('activateReqObj');
      (!isSpocUser) && app.identityService.sessionService.setUpSessionInfo({...data, userOpted: 'RemindLater'}, true);
    });
  };

  render() {
    const { MFAOpen, MFAOpen1, isTimeout, showLoader } = this.state;

    if(showLoader){
      return <LoadIndicator showLoading />;
    }

    if (isTimeout) {
      return <TimeOut />;
    }

    if (MFAOpen) {
      return <TurnOnMFAContainer onClose={this.handleCloseModal} />;
    }
    if (MFAOpen1) {
      return <NeverAskAgainPopup />;
    }
    return (
      <MfaModal isOpen>
        <h2 className={classes.heading}>{this.strings.heading}</h2>
        <p className={classes.content}>{this.strings.content}</p>
        <p>
          <b>{this.strings.optInQuestion}</b>
        </p>
        <div className={classes.optButtons}>
          <button onClick={this.handleOpenModal} className={classes.optIn}>{this.strings.optInButton}</button>
          <button onClick={this.remindLater} className={classes.remindMeLater}>{this.strings.remindMeLaterButton}</button>
          <button onClick={this.handleOpenModal1} className={classes.neverAskAgain}>{this.strings.neverAskAgainButton}</button>
        </div>
      </MfaModal>
    );
  }
}

export default MFAOptionsContainer;
